import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";
import { useLocation } from "@reach/router";

const addTranslatorRegister = (postData) => {
  return http().post(endpoints.auth.translatorRegister, postData);
};

export function useTranslatorRegister() {
  return useMutation(addTranslatorRegister, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
